import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { Badge, ChevronDownIcon, Dropdown, Text, TextButton, type TypeDropdownOption } from '@thefarmersfront/kitchen';

import { BrandLogo, SmartSearchButton } from '~/components/common';

import { useUserInfoStore } from '~/store';

import { USER_MENU_OPTIONS } from '~/constants';

import styles from './Header.module.scss';

const Header = () => {
  return (
    <div className={styles['header-wrapper']}>
      <div className={styles['header-left-field']}>
        <HeaderLogo />
        <Text className={styles['header-version']} size="small" color="tertiary">
          v {process.env.npm_package_version}
        </Text>
      </div>
      <div className={styles['header-right-field']}>
        <HeaderRightContents />
      </div>
    </div>
  );
};

const HeaderLogo = () => {
  return (
    <button className={styles['header-logo']}>
      <BrandLogo />
    </button>
  );
};

const HeaderRightContents = () => {
  const navigate = useNavigate();

  const [isUserInfoDropdownOpen, setIsUserInfoDropdownOpen] = useState(false);

  const { userInfo } = useUserInfoStore();

  const userInfoContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleDocumentClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isInsideSelectBox = userInfoContainerRef.current?.contains(target);

      if (!isInsideSelectBox) {
        setIsUserInfoDropdownOpen(false);
      }
    };

    isUserInfoDropdownOpen && document.addEventListener('mousedown', handleDocumentClick, true);

    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, [isUserInfoDropdownOpen]);

  const handleUserInfoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    setIsUserInfoDropdownOpen((prev) => !prev);
  };

  const onUserInfoDropdownChange = async (
    _: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    option: TypeDropdownOption | null
  ) => {
    if (!option) {
      return;
    }

    setIsUserInfoDropdownOpen(false);
    navigate(option.value as string);
  };

  return (
    <div className={styles['right-contents-wrapper']}>
      <SmartSearchButton />
      <Badge variant="light" size="small">
        {userInfo.ownerName}
        <Text size="xsmall" weight="semi-bold" color="point">
          {userInfo.ownerType}
        </Text>
      </Badge>
      <div ref={userInfoContainerRef} className={styles['user-info-container']}>
        <TextButton
          className={`${styles['user-info-button']} ${isUserInfoDropdownOpen ? styles['open'] : ''}`}
          href={undefined}
          size="small"
          color="secondary"
          rightIcon={<ChevronDownIcon size={16} />}
          onClick={handleUserInfoClick}
        >
          {`${userInfo.name}님`}
        </TextButton>
        {isUserInfoDropdownOpen && (
          <div className={styles['user-info-dropdown']}>
            <Dropdown options={USER_MENU_OPTIONS} size="small" onChange={onUserInfoDropdownChange} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
